<template>
    <div class="block-editor google-drive-get-file-info">
        <section>
            <div class="title">{{ $t('auto.googleDriveGetFileInfoChannelId') }}</div>
            <TiptapEditor placeholder="Google Drive Channel ID" :show-attributes="true" v-model="clone.channelId" automation-mode />
            <small>{{ $t('auto.googleDriveGetFileInfoGoogleDriveKanalIdsi') }}</small>
        </section>
        <section>
            <div class="title">{{ $t('auto.googleDriveGetFileInfoFileId') }}</div>
            <TiptapEditor placeholder="Google Drive File ID" :show-attributes="true" v-model="clone.fileId" automation-mode />
            <small>{{ $t('auto.googleDriveGetFileInfoBilgisiAlNacakDosyanNGoogleDriveIdsi') }}</small>
        </section>
    </div>
</template>

<script>
import _ from "lodash";
import TiptapEditor from "../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
export default {
    name: "GoogleDriveGetFileInfo",
    components: {
        TiptapEditor,
    },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep({
                channelId: "",
                fileId: "",
                ...this.value
            }),
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.google-drive-get-file-info {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    section {
        margin-bottom: 20px;
    }

    .title {
        font-weight: bold;
        margin-bottom: 5px;
    }

    small {
        color: #777;
    }
}
</style>
